import { gradeFromGradYear } from "@/utils/gradeFromGradYear";
import type { ClassAttendanceRow } from "@/types/tables";

export const buildClassAttendanceRows = (
  data: {
    student: {
      _id: string;
      name: string;
      email: string;
      gradYear: number;
    };
    present: boolean;
    reason: string;
  }[],
): ClassAttendanceRow[] => {
  return data.map((r) => ({
    studentId: r.student._id,
    studentName: r.student.name,
    studentEmail: r.student.email,
    studentGradeLevel: gradeFromGradYear(r.student.gradYear),
    present: r.present,
    reason: r.reason,
  }));
};
